export const resetMetricsObj = () => {
  return {
    type: 'RESET_METRICS_OBJ',
    payload: {},
  }
}
export const resetMetricsStatus = (reset) => {
  return {
    type: 'RESET_METRICS_STATUS',
    payload: reset,
  }
}

export const metricsError = (error) => {
  return {
    type: 'METRICS_ERROR',
    payload: error,
  }
}

export const getMetrics = () => {
  return {
    type: 'GET_METRICS',
    payload: {},
  }
}
export const setMetrics = (data) => {
  return {
    type: 'SET_METRICS',
    payload: data,
  }
}

export const updateMetrics = (status) => {
  return {
    type: 'UPDATE_METRICS',
    payload: status ?? true,
  }
}

export const expandedMetricsArea = (status) => {
  return {
    type: 'EXPANDED_METRICS_AREA',
    payload: {
      expanded: status ?? true,
    },
  }
}
